export enum ItemsHeader {
  HIGHLIGHTS = "HIGHLIGHTS",
  NEWS = "NEWS",
  OUTSTANDING = "OUTSTANDING",
  FINISHED = "FINISHED",
}

export enum StatusTask {
  NEW = "NEW",
  PENDING = "PENDING",
  IN_PROGRESS = "IN PROGRESS",
  FINISHED = "FINISHED",
}
